// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"abdeff00","455":"1691c7a1","977":"120e390f"}[chunkId] + ".chunk.js";
};